import React from 'react';
import get from 'lodash/get';

import PriceSpan from 'common/components/formatters/PriceSpan';
import { getLineItemCommitmentRewardAdjustmentTotal } from '../../selectors';
import { TranslatedMessage } from 'common/components/Intl';
import { getPodCount } from 'common/utils/lineItem';
import taxonQuantityLimit from 'common/utils/taxonQuantityLimit';
import LineItemPrice from 'common/components/shop/LineItemPrice';
import LineItem from 'common/components/shop/LineItem';

interface Props {
  disableQuantityInputForCommitmentRewards?: boolean;
  discountContentKey?: string;
  displayDiscount: boolean;
  handleQuantityChange(config: any): void;
  item: LineItem;
  originalPrice: number;
  quantityProcessing?: number;
  showStrikethroughPrices: boolean;
  totalPrice: number;
  variants: Variant[];
}

export function getTaxonQuantityLimitForLineItem(item) {
  const taxonName = get(item, 'product.taxons[0].name');
  return taxonQuantityLimit(taxonName, getPodCount(item));
}

export class CartLineItem extends React.Component<Props> {
  handleQuantityChange = (quantity: number) =>
    this.props.handleQuantityChange({ quantity, lineItem: this.props.item });

  handleItemRemoval = () => this.handleQuantityChange(0);

  render() {
    const {
      disableQuantityInputForCommitmentRewards,
      discountContentKey,
      displayDiscount,
      item,
      originalPrice,
      quantityProcessing,
      showStrikethroughPrices,
      totalPrice,
      variants,
    } = this.props;

    const commitmentTotal = getLineItemCommitmentRewardAdjustmentTotal(item);
    const podCount = getPodCount(item);
    const variant = variants.find(v => v.sku === item.sku);
    const strength = variant.nicotine_strength;

    const quantity = Number.isInteger(quantityProcessing)
      ? quantityProcessing
      : item.quantity;

    const details =
      strength && podCount ? (
        <>
          <TranslatedMessage
            id={'cart.nicotine_strength'}
            values={{ strength }}
          />
          <br />
          <TranslatedMessage
            id={'cart.pod_count'}
            values={{ pod_count: podCount }}
          />
          {' - '}
          <TranslatedMessage
            id={'cart.price_each'}
            values={{
              price: <PriceSpan amount={parseFloat(item.price)} />,
            }}
          />
        </>
      ) : (
        item.options_text
      );

    const lineItemPrice = (
      <LineItemPrice
        discountContentKey={
          discountContentKey ? `cart.sidebar.${discountContentKey}` : null
        }
        originalPrice={displayDiscount ? originalPrice : null}
        price={totalPrice}
        strikethrough={showStrikethroughPrices}
      />
    );

    return (
      <LineItem
        details={details}
        imageUrl={`${item.image}`}
        name={variant.name}
        onQuantityChange={this.handleQuantityChange}
        onRemove={this.handleItemRemoval}
        price={lineItemPrice}
        quantity={quantity}
        quantityControls={
          !commitmentTotal || !disableQuantityInputForCommitmentRewards
        }
        quantityMaximum={getTaxonQuantityLimitForLineItem(item)}
        url={variant.url}
      />
    );
  }
}
